import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { IntegrationCatalog } from "@modules/erpIntegrations/types";
import { IntegrationFormValues } from "@modules/erpIntegrations/validations";
import { getErpErrorMessage } from "@modules/erpIntegrations/utils";

import { createIntegrationService } from "./service";
import { UseCreateIntegrationMutationOptions } from "./types";

export function useCreateIntegrationMutation(
  options?: UseCreateIntegrationMutationOptions
) {
  const { open } = useNotification();

  return useMutation<IntegrationCatalog, ApiError, IntegrationFormValues>({
    mutationFn: createIntegrationService,
    ...options,
    onError: (error, variables, context) => {
      open?.({
        type: "error",
        message: getErpErrorMessage(error),
      });
      options?.onError?.(error, variables, context);
    },
  });
}
